import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

function People({ teamMembers }) {

    return (
        <div className="bg-[#e5dedb] min-h-screen">
            <Header />
            <div id="team-members" className="md:pt-[5%] pt-16 py-8 md:px-[15%] bg-e5dedb ">
                <h2 className="text-3xl font-bold mb-8 text-center">Meet The Team</h2>
                <div className="grid md:grid-cols-2 gap-8">
                    {teamMembers.map((member, idx) => (
                        <Link to={`/people/${member.id}`} key={idx}>
                            <div className="text-center">
                                <img src={member.image} alt={`Team Member ${idx + 1}`} className="w-[70%] max-w-xs mx-auto h-auto object-cover rounded mb-4" />
                                <h3 className="text-xl font-bold mb-1">
                                    {member.name == "Gerard Hooi" ? <><span>{member.name}</span><span className="text-sm">{", PBM"}</span></> : member.name}
                                </h3>
                                <p className="text-gray-700">{member.role}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default People;
